import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {PaymentInvoice, PaymentInvoiceSearchParams, PaymentInvoiceType} from '@accounting/_common/models/payment-invoice.models';

export const CheckState = createAction(
    '[PaymentInvoices] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: PaymentInvoice[], documentType: PaymentInvoiceType | 'CROSS' } }>()
);

export const CheckStateSuccess = createAction(
    '[PaymentInvoices] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: PaymentInvoice[], documentType: PaymentInvoiceType | 'CROSS' } }>()
);

export const LoadList = createAction(
    '[PaymentInvoices] Load List',
    props<{ payload: { loading: DahLoadingType, documentType: PaymentInvoiceType | 'CROSS', clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[PaymentInvoices] Load List Success',
    props<{ payload: { items: PaymentInvoice[], pagination: DahPaginationModel, documentType: PaymentInvoiceType | 'CROSS', clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[PaymentInvoices] Load List Failure',
    props<{ payload: { error: HttpErrorResponse, documentType: PaymentInvoiceType | 'CROSS' } }>()
);

export const SetPagination = createAction(
    '[PaymentInvoices] Set Pagination',
    props<{ payload: { next: boolean, documentType: PaymentInvoiceType | 'CROSS' } }>()
);

export const SetFilter = createAction(
    '[PaymentInvoices] Set Filter',
    props<{ payload: { filter: PaymentInvoiceSearchParams, documentType: PaymentInvoiceType | 'CROSS' } }>()
);

export const SetLoading = createAction(
    '[PaymentInvoices] Set Loading',
    props<{ payload: { loading: DahLoadingType, documentType: PaymentInvoiceType | 'CROSS' } }>()
);

export const SetItemsLoading = createAction(
    '[PaymentInvoices] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean, documentType: PaymentInvoiceType | 'CROSS' } }>()
);

export const UpdateItemSuccess = createAction(
    '[PaymentInvoices] Update Item Success',
    props<{ payload: { item: PaymentInvoice, documentType: PaymentInvoiceType | 'CROSS' } }>()
);

export const DeleteItem = createAction(
    '[PaymentInvoices] Delete Item',
    props<{ payload: { item: PaymentInvoice, documentType: PaymentInvoiceType | 'CROSS' } }>()
);

export const DeleteItemSuccess = createAction(
    '[PaymentInvoices] Delete Item Success',
    props<{ payload: { item: PaymentInvoice, documentType: PaymentInvoiceType | 'CROSS' } }>()
);

export const DeleteItemFailure = createAction(
    '[PaymentInvoices] Delete Item Failure',
    props<{ payload: { item: PaymentInvoice, documentType: PaymentInvoiceType | 'CROSS' } }>()
);

export const SetInitialState = createAction(
    '[PaymentInvoices] Set Initial State'
);
